'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import Compressor from 'compressorjs';
import { ImageUploadLine } from '@zealy/icons';
import { cn } from '../../utils/cn';
import { getComponentState } from '../../utils/getComponentState';
import { InputLabel } from '../InputLabel';
import { hintStyles, imageStyles, inputStyles } from './PictureField.styles';
export const PictureField = ({ label, name, isInvalid, isDisabled, hint, className, src, onValueChange, size, disableCompression, ...props }) => {
    const state = getComponentState({
        isDisabled,
        isInvalid,
    });
    const ref = useRef(null);
    const [preview, setPreview] = useState('');
    const handleChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (disableCompression) {
                setPreview(URL.createObjectURL(file));
                onValueChange?.(file);
            }
            else {
                new Compressor(file, {
                    maxWidth: 500,
                    quality: 0.8,
                    success: image => {
                        const compressedFile = new File([image], 'logo.png', {
                            type: image.type,
                        });
                        setPreview(URL.createObjectURL(file));
                        onValueChange?.(compressedFile);
                    },
                });
            }
        }
    };
    return (_jsxs("div", { className: cn('flex flex-col gap-100 items-start justify-start'), children: [_jsx(InputLabel, { name: name, size: size, isDisabled: isDisabled, label: label }), _jsxs("div", { className: cn(inputStyles({
                    state,
                    size,
                }), className), onClick: () => !isDisabled && ref.current?.click(), children: [src || preview ? (_jsx("img", { src: preview || src, alt: name, width: "auto", height: "auto", className: imageStyles({
                            size,
                        }), onLoad: () => URL.revokeObjectURL(preview) })) : (_jsx(ImageUploadLine, { className: "text-secondary", width: 20 })), _jsx("input", { id: name, name: name, ref: ref, type: "file", className: "hidden", ...props, onChange: handleChange, disabled: isDisabled })] }), !!hint && _jsx("p", { className: hintStyles({ state, size }), children: hint })] }));
};
